import { Variants, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import GetInTouch from "../../components/get-in-touch";
import BookAppointment from "../../components/servicesComponents/book-appointment";
import Card from "../../components/servicesComponents/card";
import DedicatedBeauty from "../../components/servicesComponents/dedicated-beauty";
import { servicesData } from "../../data/servicesData";
import { IServiceDataModel } from "../../shared/models/serviceData.model";
import styles from "./services.module.scss";
import MembershipsPromo from "../../components/servicesComponents/memberships";
function getRandomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

// Map URL-friendly category names to internal category names
const categoryMap: { [key: string]: string } = {
  extensions: "extensions",
  color: "color",
  haircuts: "haircuts",
  styling: "styling",
  "add-ons": "addOns",
};

const Services = () => {
  const { category } = useParams<{ category: string }>();
  const navigate = useNavigate();
  
  // Map URL category to internal category name
  const internalCategory = category ? categoryMap[category] || "extensions" : "extensions";
  const [activeTab, setActiveTab] = useState<string>(internalCategory);
  const [serviceList, setServiceList] = useState<IServiceDataModel[]>([]);
  const [servicesCards, setServicesCards] = useState<any>();
  const BOOKING_URL = `https://www.vagaro.com/lawameraki/services`;

  // Update active tab when URL changes
  useEffect(() => {
    if (category && categoryMap[category]) {
      setActiveTab(categoryMap[category]);
    } else if (category && !categoryMap[category]) {
      // Invalid category, redirect to extensions
      navigate("/services/extensions", { replace: true });
    } else if (!category) {
      setActiveTab("extensions");
    }
  }, [category, navigate]);

  useEffect(() => {
    const data: any = servicesData[activeTab];
    setServiceList(data);
  }, [activeTab]);

  // Function to handle tab change and navigation
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    // Find the URL-friendly category name
    const urlCategory = Object.keys(categoryMap).find(
      (key) => categoryMap[key] === tab
    ) || "extensions";
    navigate(`/services/${urlCategory}`, { replace: true });
  };

  const headingVariants: Variants = {
    headingOffScreen: {
      opacity: 0,
      scale: 0.6,
      filter: "blur(20px)",
      transform: "translateY(-50px)",
    },
    headingOnScreen: {
      opacity: 1,
      scale: 1,
      filter: "blur(0px)",
      transform: "translateY(0px)",
      transition: {
        duration: getRandomFloat(0.8, 1.0),
      },
    },
  };

  useEffect(() => {
    const tempServicesCards: any = serviceList.map(
      (service: any, index: number) => {
        return (
          <div key={index} className={styles["service-card"]}>
            <Card data={service} />
          </div>
        );
      }
    );

    setServicesCards(tempServicesCards);
  }, [serviceList]);
  return (
    <>
      <motion.div
        initial="imageOffScreen"
        whileInView="imageOnScreen"
        variants={headingVariants}
      >
        <div className={styles["container"]}>
          <motion.div
            initial="headingOffScreen"
            whileInView="headingOnScreen"
            variants={headingVariants}
          >
            <h1>Our Premiere salon services </h1>
          </motion.div>

          <div className={styles["services-tabs-buttons"]}>
            <h1
              className={activeTab === "extensions" ? styles["active-tab"] : ""}
              onClick={(event: any) => {
                handleTabChange("extensions");
              }}
            >
              Extensions
            </h1>
            <h1
              className={activeTab === "color" ? styles["active-tab"] : ""}
              onClick={(event: any) => {
                handleTabChange("color");
              }}
            >
              Color
            </h1>
            <h1
              className={activeTab === "haircuts" ? styles["active-tab"] : ""}
              onClick={(event: any) => {
                handleTabChange("haircuts");
              }}
            >
              Haircuts
            </h1>
            <h1
              className={activeTab === "styling" ? styles["active-tab"] : ""}
              onClick={(event: any) => {
                handleTabChange("styling");
              }}
            >
              Styling
            </h1>
            <h1
              className={activeTab === "addOns" ? styles["active-tab"] : ""}
              onClick={(event: any) => {
                handleTabChange("addOns");
              }}
            >
              Add-Ons
            </h1>
          </div>

          <div className={styles["active-service-tab-container"]}>
            {/* <h1>{activeTab.toLocaleUpperCase()}</h1> */}
            <div className={styles["services-card-container"]}>
              {servicesCards && servicesCards}
            </div>
          </div>
          <motion.div
            initial="headingOffScreen"
            whileInView="headingOnScreen"
            variants={headingVariants}
          >
            <button
              onClick={() => {
                window.open(BOOKING_URL, "_blank");
              }}
            >
              Book
            </button>
          </motion.div>
        </div>
      </motion.div>
      <motion.div
        initial="imageOffScreen"
        whileInView="imageOnScreen"
        variants={headingVariants}
        className={styles["box"]}
      >
        <BookAppointment />
      </motion.div>
      <motion.div
        initial="imageOffScreen"
        whileInView="imageOnScreen"
        variants={headingVariants}
        className={styles["box"]}
      >
        <MembershipsPromo />
      </motion.div>
      <motion.div
        initial="imageOffScreen"
        whileInView="imageOnScreen"
        variants={headingVariants}
        className={styles["box"]}
      >
        <DedicatedBeauty />
      </motion.div>
      <motion.div
        initial="imageOffScreen"
        whileInView="imageOnScreen"
        variants={headingVariants}
      >
        <GetInTouch />
      </motion.div>
    </>
  );
};

export default Services;
